import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/admin-user.php';

export function getAdminUsers(filters = {}) {
    // Remove filtros vazios antes de enviar
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;
    
    const response = api.get(url);

    return response;
};

export function getAdminUserDetails(id) {

    const response = api.get(`${service_path}?user_id=${id}`)

    return response;
};

export function getAdminUserPermissions(id) {

    const response = api.get(`admin-user-permissions.php?user_id=${id}`)

    return response;
};

export function createAdminUser(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Usuário criado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updateAdminUser(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Usuário editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updateAdminUserPermissions(data, navigateBack) {

    api.patch('admin-user-permissions.php', data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Usuário editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deleteAdminUser(id, user_id) {

    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;

            if (data.success) {
                globalToast.success("Usuário deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar esse usuário!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};